import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE: InjectionToken<Storage> = new InjectionToken<Storage>('Local storage', {
  providedIn: 'root',
  factory: () => window.localStorage,
});
